import React from "react"
import styled from "@emotion/styled"
import { Box } from "@rebass/grid/emotion"

import SEO from "../../../../components/wild/global/seo"
import ProductOptionsSchema from "../../../../components/wild/global/productoptionsschema/productoptionsschema"
import MenATCActiveCleanse from "../../../../components/wild/men/product/atcarea/menatc-active-cleanse"
import Banner from "../../../../components/wild/men/activecleanse/banner-active-cleanse.js"
import Nutraceutical from "../../../../components/wild/men/activecleanse/nutraceutical.js"
import Comparison from "../../../../components/wild/men/activecleanse/comparison"
import Faq from "../../../../components/wild/men/faq/faq"
import References from "../../../../components/wild/global/references/references"

import { data } from "../../../../data/men/shampoo-conditioner"
import { meshProductDataRadio } from "../../../../utils/productloader"

const Wrapper = styled.div`
  .refs {
    span {
      color: #fff !important;
    }
  }
`
const purchase_source = `mens_active_cleanse_pdp`

const Men = (props) => {
  const mageProducts = props.pageContext.products
  const meshedProductData = meshProductDataRadio(mageProducts, data)

  return (
    <Wrapper>
      <SEO
        title={meshedProductData.seo.title}
        description={meshedProductData.seo.description}
      />
      <ProductOptionsSchema options={meshedProductData.radioArea.options} />
      <Banner data={data.banner} />
      <MenATCActiveCleanse
        data={meshedProductData.radioArea}
        purchase_source={purchase_source}
      />
      <Comparison data={meshedProductData.comparison} />
      <Nutraceutical data={meshedProductData.nutraceutical} />
      <Faq data={meshedProductData.faqContact} />
      <Box className={`refs`}>
        <References data={meshedProductData.references} />
      </Box>
    </Wrapper>
  )
}

export default Men
